export function LoadingSpinner() {
  return (
    <div role="status" aria-label="Loading" className="flex flex-col items-center justify-center h-full min-h-[400px] gap-4">
      <div className="adp-spinner w-16 h-16" />
      <p className="text-sm text-mono text-muted-foreground uppercase tracking-wider animate-pulse">
        Loading...
      </p>
    </div>
  );
}

// Full screen loading (for route transitions)
export function FullScreenLoading() {
  return (
    <div className="fixed inset-0 bg-background flex items-center justify-center z-50">
      <LoadingSpinner />
    </div>
  );
}
